import { useAuth } from '../app/hooks/useAuth';

type AppLayoutProps = {
  children: React.ReactNode;
};

const AppLayout = ({ children }: AppLayoutProps) => {
  const { signOut } = useAuth();
  
  return (
    <div className="app-layout bg-white min-h-screen">
      {/* Background gradient elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] rounded-full opacity-10 bg-gradient-to-b from-[#ff8c42]/10 to-transparent blur-3xl -translate-y-1/2 translate-x-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full opacity-5 bg-gradient-to-t from-[#946e5d]/10 to-transparent blur-3xl translate-y-1/3 -translate-x-1/3"></div>
      </div>
      
      {/* App header */}
      <header className="bg-white shadow-sm border-b border-gray-100 p-4 sticky top-0 z-10">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center">
            <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z" stroke="#FF8C42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 28C24.4183 28 28 24.4183 28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 24.4183 15.5817 28 20 28Z" fill="#FF8C42"/>
            </svg>
            <span className="ml-2 text-gray-800 font-bold text-xl">MailMaid</span>
          </div>
          
          <div className="flex items-center">
            <nav className="hidden md:flex mr-8">
              <a href="#" className="text-[#ff8c42] font-medium mx-3 border-b-2 border-[#ff8c42] pb-1">Dashboard</a>
              <a href="#" className="text-gray-600 hover:text-gray-800 transition-colors mx-3">Analytics</a>
              <a href="#" className="text-gray-600 hover:text-gray-800 transition-colors mx-3">Settings</a>
              <a href="#" className="text-gray-600 hover:text-gray-800 transition-colors mx-3">Help</a>
            </nav>
            
            <div className="flex items-center space-x-4">
              <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors relative">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                </svg>
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#ff8c42] rounded-full"></span>
              </button>
              
              <div className="w-8 h-8 bg-[#ff8c42] rounded-full flex items-center justify-center text-white font-medium cursor-pointer">
                U
              </div>
              
              <button 
                onClick={signOut}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-800 transition-colors px-3 py-1.5 rounded-lg text-sm border border-gray-200"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>
      
      {/* Main content */}
      <main className="container mx-auto py-6 px-4 relative z-[1]">{children}</main>
      
      {/* App footer */}
      <footer className="border-t border-gray-100 py-6 mt-12 relative z-[1]">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center mb-4 md:mb-0">
              <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z" stroke="#FF8C42" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M20 28C24.4183 28 28 24.4183 28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 24.4183 15.5817 28 20 28Z" fill="#FF8C42"/>
              </svg>
              <span className="ml-2 text-gray-800 font-medium">MailMaid</span>
            </div>
            
            <div className="flex space-x-4 text-sm text-gray-500">
              <a href="#" className="hover:text-[#ff8c42]">Privacy</a>
              <a href="#" className="hover:text-[#ff8c42]">Terms</a>
              <a href="#" className="hover:text-[#ff8c42]">Contact</a>
              <span>© 2023 MailMaid</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AppLayout;